import YwMultipleCascader from "./src/select.vue";
import { Select,Checkbox,Icon } from "ant-design-vue"

YwMultipleCascader.install = function (Vue) {
	Vue.use(Icon)
	Vue.use(Select)
	Vue.use(Checkbox)
	Vue.component(YwMultipleCascader.name, YwMultipleCascader);
};

export default YwMultipleCascader;
